module.exports = __webpack_public_path__ + "img/rocket_half.c5182da0.svg";